exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-bbe6597a]{border:1px solid #ececec;text-align:center;padding:.16rem .1rem}a[data-v-bbe6597a]{word-break:break-all;cursor:pointer}b[data-v-bbe6597a]{font-weight:700;color:#151515}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bbe6597a","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/landingPage/policy.vue
// module id = 686
// module chunks = 18